"use client";

import type React from "react";
import { useEffect, useRef } from "react";
import { getWindow } from "../../../helpers/getWindow";
import { isDachProduct } from "../../../helpers/isDachProduct";
import { useCountry } from "../../../hooks/useCountry";
import { useIsPageChange } from "../../../hooks/useIsPageChange";
import { useConsent, useIsPay } from "../../Consent/hooks";

export const GoogleInterstitial: React.FC = () => {
    const country = useCountry();
    const consent = useConsent();
    const isPay = useIsPay();
    const window = getWindow();
    const googleInterstitialInitialised = useRef(false);
    const isPageChange = useIsPageChange();

    // eslint-disable-next-line react-hooks/immutability
    useEffect(() => {
        if (!consent || isPay || !window || !isDachProduct(country)) {
            return;
        }

        window.googletag = window.googletag || { cmd: [] };

        if (!googleInterstitialInitialised.current) {
            window.googletag.cmd.push(() => {
                window.googletag.pubads().enableSingleRequest();
                window.googletag.pubads().disableInitialLoad();
                window.googletag.enableServices();
            });

            googleInterstitialInitialised.current = true;
        }

        let slotName = "/16486012/WET_DE_M_interstitial";
        if (country === "at") {
            slotName = "/16486012/WET_AT_M_interstitial";
        } else if (country === "ch") {
            slotName = "/16486012/WET_CH_M_interstitial";
        }

        window.googletag.cmd.push(() => {
            // eslint-disable-next-line no-console
            console.log("[GTM Interstitial] Initialising");
            const slot = googletag.defineOutOfPageSlot(
                slotName,
                window.googletag.enums.OutOfPageFormat.INTERSTITIAL
            );
            if (slot) {
                slot.addService(window.googletag.pubads());
                setTimeout(() => {
                    window.googletag.pubads().refresh([slot]);
                }, 2000);
            }
        });

        return (): void => {
            if (typeof window.googletag.pubads === "function") {
                const slot = window.googletag
                    .pubads()
                    .getSlots()
                    .find((s) => s.getAdUnitPath() === slotName);

                if (slot) {
                    window.googletag.cmd.push(() => {
                        // eslint-disable-next-line no-console
                        console.log("[GTM Interstitial] Destroying");
                        window.googletag.destroySlots([slot]);
                    });
                }
            }
        };
    }, [country, consent, isPay, isPageChange, window]);

    return null;
};
